import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import FooterEtapa from 'pages/FluxoProjetos/Components/footerEtapa/footerEtapa';
import TitleEtapa from 'pages/FluxoProjetos/Components/titleEtapa/titleEtapa';
import { useContext, useLayoutEffect } from 'react';
import AssessoresPedagogicos from '../campos/assessoresPedagogicos';
import Cooperativa from '../campos/cooperativa';
import Educadores from '../campos/educadores';
import EtapasEducacao from '../campos/etapasEducacao';
import Instituicao from '../campos/instituicao';
import Modalidade from '../campos/modalidade';
import PeriodoInicial from '../campos/periodoInicial';
import PreTitulo from '../campos/preTitulo';
import QuantidadeCriancasAdolescentes from '../campos/quantidadeCriancasAdolescentes';
import Turmas from '../campos/turmas';
import styles from './etapas.scss';
const { rootClassName } = styles;

const etapa = EtapaProjeto.infosIniciais;
export default function InfosIniciais() {
  const { dispatch } = useContext(ProjetosContext);

  useLayoutEffect(() => {
    dispatch({ type: 'setEtapa', payload: etapa });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={rootClassName}>
      <TitleEtapa etapa={etapa} />
      <div className={`${rootClassName}-scrollable`}>
        <Instituicao />
        <Cooperativa />
        <AssessoresPedagogicos />
        <Educadores />
        <Turmas />
        <QuantidadeCriancasAdolescentes />
        <EtapasEducacao />
        <Modalidade />
        <PreTitulo />
        <PeriodoInicial />
      </div>
      <FooterEtapa etapa={etapa} />
    </div>
  );
}
